import Baskerville from './BaskervilleItalicBT.ttf';

export default Baskerville;
